// 发送的消息  已读状态管理

// let WebIM = require("./WebIM")["default"];
let disp = require("./broadcast");
// let msgStorage = require("@/components/chat/msgstorage.js");
// import messageApi from "@/api/message/message.js"
// 未读消息数据格式为
let unReadMsgManageMap = {
	// 获取本地未读消息IDs
	// getLocalUnreadMsgIds: () => {
	// 	let tempUnreadMsgIds = uni.getStorageSync('unreadMsgIds')
	// 	let arr = []
	// 	if (
	// 		tempUnreadMsgIds &&
	// 		tempUnreadMsgIds.length
	// 	) {
	// 		arr = tempUnreadMsgIds

	// 	}
	// 	getApp().globalData.unreadMsgIds = arr
	// 	disp.fire('UNDATE_UNREAD_IDS', arr)
	// },
	// 添加消息到未读IDs
	addMsgToUnreadIds: (msgId) => {
		// msgId 为消息的环信id
		let arr = getApp().globalData.unreadMsgIds
		if (arr && arr.length) {
			if (arr.indexOf(msgId) == -1) arr.push(msgId)
		} else {
			arr = [msgId]
		}



		getApp().globalData.unreadMsgIds = arr
		disp.fire('UNDATE_UNREAD_IDS', arr)
	},
	DELETE_UNREAD_ID_ONE: (id) => {
		// 删除一个未读id
		let arr = getApp().globalData.unreadMsgIds
		if (arr && arr.length) {
			let index = arr.indexOf(id)
			if (index > -1) {
				arr.splice(index, 1)
				getApp().globalData.unreadMsgIds = arr
				disp.fire('UNDATE_UNREAD_IDS', arr)
			}
		}

	},
	DELETE_UNREAD_ID_CONVER: (id) => {
		// 删除整个会话的未读消息  id为对方id
		let arr = getApp().globalData.unreadMsgIds
		// 获取到会话id 
		let myName = uni.getStorageSync("myUsername");
		let sessionKey = 'rendered_' + id + myName
		let historyChatMsgs = uni.getStorageSync(sessionKey) || [];
		if (historyChatMsgs && historyChatMsgs.length) {
			let timesMsgList = historyChatMsgs.slice(-arr.length);
			for (let i = 0; i < timesMsgList.length; i++) {
				let index = arr.indexOf(timesMsgList[i].id)
				if (index > -1) {
					arr.splice(index, 1)
					i--
				}
			}
			getApp().globalData.unreadMsgIds = arr
			disp.fire('UNDATE_UNREAD_IDS', arr)
		}
	},

}
export default unReadMsgManageMap